import { ref } from 'vue';
import { type ThemeDefinition } from 'vuetify';

import { deesplayDark } from '../styles/deesplay-dark';
import { deesplayLight } from '../styles/deesplay-light';

export interface SharedPluginOptions {
	locale: 'de-DE' | 'en-US' | 'fr-FR';
	fallbackLocale: 'de-DE' | 'en-US' | 'fr-FR';
	message: Record<string, Record<string, string>>;
	theme: string;
	themes: Record<string, ThemeDefinition>;
}

export const defaultOptions = ref<SharedPluginOptions>({
	locale: 'fr-FR',
	fallbackLocale: 'fr-FR',
	message: {},
	theme: 'LIGHT',
	themes: {
		DARK: deesplayDark,
		LIGHT: deesplayLight
	}
});